import { render, staticRenderFns } from "./app.partner.page.vue?vue&type=template&id=0575dc5b&scoped=true&"
import script from "./app.partner.page.vue?vue&type=script&lang=js&"
export * from "./app.partner.page.vue?vue&type=script&lang=js&"
import style0 from "./app.partner.page.vue?vue&type=style&index=0&id=0575dc5b&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0575dc5b",
  null
  
)

export default component.exports